import { useEffect } from "react";

const NonAuthPage = (props: any) => {
    useEffect(() => {
        if (props.userAuthenticated === true) {
            window.location.href = "/";
        }
    }, [props]);

    return props.children;
};

export default NonAuthPage;
